import { Header } from 'header'
import { Workspace as View } from 'ui-components'
import { CheckoutSuccess } from './CheckoutSuccess'
import { TabBar } from './TabBar'
import { Tab } from './Tabs'
import { WorkspaceInfo } from './WorkspaceInfo'

const Workspace = () => {
  return (
    <View
      slots={{
        CheckoutSuccess,
        Header,
        WorkspaceInfo,
        TabBar,
        Tab
      }}
    />
  )
}

export { Workspace }
